import { render, staticRenderFns } from "./NewDrawingDialog.vue?vue&type=template&id=289bc53e&scoped=true&"
import script from "./NewDrawingDialog.vue?vue&type=script&lang=ts&"
export * from "./NewDrawingDialog.vue?vue&type=script&lang=ts&"
import style0 from "./NewDrawingDialog.vue?vue&type=style&index=0&id=289bc53e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289bc53e",
  null
  
)

export default component.exports